import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import classnames from 'classnames';

import SocialsLinks from './SocialsLinks';
import SpeakerCommunityLike from './SpeakerCommunityLike';
import WebsitesLinks from './WebsitesLinks';

const Props = {
    speakerSocials: PropTypes.object.isRequired,
    speakerCommunityLike: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    prefix: PropTypes.string,
    company: PropTypes.string,
    position: PropTypes.string,
    bio: PropTypes.string,
    websites: PropTypes.array,
    eventUrls: PropTypes.object,
    showEmailLogin: PropTypes.func.isRequired,
};

const SpeakerBio = (props) => {
    const {
        speakerSocials,
        speakerCommunityLike,
        name,
        prefix,
        suffix,
        company,
        position,
        bio,
        websites,
        eventUrls,
        showEmailLogin,
        setLoginV2OffsetTop,
        siteConf,
    } = props;
    const bioCls = classnames(
        'speaker-bio white-space-pre margin-top-small margin-bottom-small padding-left-small',
        { 'padding-bottom-medium': websites.length !== 0 }
    );

    return (
        <Fragment>
            <Row>
                <Col lg={3} md={4} sm={3} xs={12} lgPush={9} mdPush={8} smPush={9} className="
                            speaker-socials-wrapper
                            bz-flex-row
                            xs-padding-horizontal
                        ">
                    <div className="speaker-community-like-wrapper custom-color color-1 hidden-lg hidden-md hidden-sm">
                        <SpeakerCommunityLike
                            {...speakerCommunityLike}
                            showEmailLogin={showEmailLogin}
                            eventUrls={eventUrls}
                            setLoginV2OffsetTop={setLoginV2OffsetTop}
                            siteConf={siteConf}
                        />
                    </div>
                </Col>
                <Col lg={9} md={8} sm={9} xs={12} lgPull={3} mdPull={4} smPull={3}>
                    <div className="speaker-name-wrapper bz-flex-row">
                        <h1 className="speaker-name bz-bold custom-font margin-right-small">
                            {`${prefix} `}{`${name}`}{` ${suffix}`}
                        </h1>
                        <div className="speaker-community-like-wrapper custom-color color-1 hidden-xs">
                            <SpeakerCommunityLike
                                {...speakerCommunityLike}
                                showEmailLogin={showEmailLogin}
                                eventUrls={eventUrls}
                                setLoginV2OffsetTop={setLoginV2OffsetTop}
                                siteConf={siteConf}
                            />
                        </div>
                    </div>
                    {
                        position &&
                        <div className="speaker-position text-ellipsis">
                            {position}
                        </div>
                    }
                    {
                        company &&
                        <div className="speaker-company text-ellipsis">
                            {company}
                        </div>
                    }
                    <SocialsLinks {...speakerSocials} />
                </Col>
            </Row>
            <Row>
                {
                    bio &&
                    <Col className={bioCls} lg={12}>
                        {bio}
                    </Col>
                }
            </Row>
            { !!websites.length && <WebsitesLinks {...{ websites }} /> }
        </Fragment>
    );
};

SpeakerBio.propType = Props;

export default SpeakerBio;
